import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=c166f486&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=ts&"
export * from "./RegisterUser.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=c166f486&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c166f486",
  null
  
)

export default component.exports